module.exports = __webpack_public_path__ + "media/images/new-target-icon-e24df96f.png";